import UpdaterFactory from './Factory';
import UpdaterSelector from './UpdaterSelector';

module.exports = {
  UpdaterFactory, UpdaterSelector
}
